import React from 'react';

type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

/**
 * Adjust-range glyph — two vertical "handle" bars bracketing a horizontal
 * double-headed arrow. Signals the drag-to-resize affordance for an
 * overlay's transcript word range (PLAT — overlay range handles).
 */
const AdjustRangeIcon = (props: Props) => {
  const { width = '16', height = '16', strokeColor = '#F3E9D7' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none">
      {/* Left handle bar */}
      <path
        d="M2.5 3.5V14.5"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* Right handle bar */}
      <path
        d="M15.5 3.5V14.5"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* Horizontal double arrow */}
      <path
        d="M5.5 9H12.5"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 6.75L5 9L7 11.25"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 6.75L13 9L11 11.25"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AdjustRangeIcon;
